import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStackedBarChart100Axis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"stacked-bar-chart-100-axis"} maskId="square-filled-radius-0-stroke-1-IconStackedBarChart100Axis"><path d="M3 3H4V20H21V21H3V3ZM7 12H8V18H7V12ZM12 10H13V18H12V10ZM17 13H18V18H17V13ZM17 5H18V11H17V5ZM7 5H8V10H7V5ZM12 5H13V8H12V5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStackedBarChart100Axis;
